import { render } from "./_tr.vue?vue&type=template&id=2606b36e"
import script from "./_tr.vue?vue&type=script&lang=js"
export * from "./_tr.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__